import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from '../locales/zh'
import en from '../locales/en'

Vue.use(VueI18n)

const  lang = (navigator.language||navigator.userLanguage).substr(0, 2);


export default new VueI18n({
    locale: localStorage.getItem('MASSWALLETLOCALE') || lang != 'zh' ? 'en-US':'zh-CN',   
    messages: {
      'zh-CN': zh, 
      'en-US': en 
    }
})